import Vue from 'vue'

const eventBus = null
const globalEventBus = () => {
  return eventBus || new Vue()
}

export default globalEventBus()

// 没有必要的话，不要随便使用全局 event bus
export const events = {
  // 素材制作页面
  DM: {
    OUTLINE: {
      NAVIGATE: 'dm/outline/navigate',
    },

    STYLE_EDITOR_POPOVER: {
      CLOSE: 'dm/style-editor-popover/close',
    },
  },

  // 权限管理
  PERMISSION: {
    CATCH: 'permission/catch',
  },
}
